import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import { Button, Chip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import classes from "../../../../components/DownloadReportButton/styles.module.css";
import { TransLoginForm } from "./TransLoginForm";

const BASE_URL = import.meta.env.VITE_APP_API_URL;

const TransForm = ({ hasCustomTransConnection, status, loginType }) => {
	const { t } = useTranslation();

	return (
		<Box sx={{ p: 0 }}>
			<Grid container spacing={5}>
				<Grid size={6}>
					<Grid container spacing={2}>
						{!hasCustomTransConnection && (
							<Grid size={12}>
								<Box
									sx={{ display: "flex", justifyContent: "start", gap: "26px" }}
								>
									<a
										className={classes.downloadLink}
										href="/CARGOseller_extension.zip"
										download={true}
										style={{
											textDecoration: "none",
											textTransform: "uppercase",
										}}
									>
										{t("download_extension")}
									</a>
									{/* todo: translate URLs */}
									<Button
										variant="contained"
										href="https://cargoseller.pl/wp-content/uploads/2024/12/Instrukcja-publikowanie-na-Trans-1.pdf"
										target="_blank"
										rel="noreferrer"
										sx={{
											background: "#e0e0e0",
											color: "#121212",
											"&:hover": {
												background: "#c9c9c9",
											},
										}}
									>
										{t("activation_instruction")}
									</Button>
									<Button
										variant="contained"
										href="https://youtu.be/XqXlC7Ce7u8"
										target="_blank"
										rel="noreferrer"
										sx={{
											background: "#e0e0e0",
											color: "#121212",
											"&:hover": {
												background: "#c9c9c9",
											},
											display: "flex",
											alignItems: "center",
											gap: "4px",
										}}
									>
										<SlowMotionVideoIcon />
										{t("video_instruction_n_min", { value: 2 })}
									</Button>
								</Box>
							</Grid>
						)}

						{hasCustomTransConnection && (
							<Grid size={12}>
								<Box
									sx={{
										mb: 1,
										display: "flex",
										alignItems: "center",
										gap: "6px",
									}}
								>
									<Typography sx={{ fontWeight: 600 }}>
										{t("status")}:{" "}
									</Typography>
									{status ? (
										<>
											<Chip label={t("integrated")} color="success" />
											<Box
												sx={{
													background: "#0288d1",
													color: "#fff",
													padding: "8px 14px",
													borderRadius: "16px",
													display: "flex",
													alignItems: "center",
													gap: "10px",
													height: "32px",
												}}
											>
												<InfoOutlinedIcon />
												<Typography sx={{ fontSize: "12px" }}>
													{t("trans_integration_info_empty_fields")}
												</Typography>
											</Box>
										</>
									) : (
										<Chip label={t("no_integration")} color="secondary" />
									)}
								</Box>
								<Box>
									{["oauth", "common", "custom"].includes(loginType) && (
										<Box sx={{ mt: "20px" }}>
											<a
												className={classes.downloadLink}
												href={`${BASE_URL}/trans_oauth_auth`}
											>
												{t("redirect_to_integration_settings")}
											</a>
										</Box>
									)}
									{loginType === "login" && (
										<Box sx={{ mt: "30px" }}>
											<TransLoginForm status={status} />
										</Box>
									)}
								</Box>
							</Grid>
						)}
					</Grid>
				</Grid>
				<Grid size={6}>{/* INFO HERE */}</Grid>
			</Grid>
		</Box>
	);
};

export default TransForm;
